import api from "@/api";
import { createLatestRequestGate, teamQuery, teamScopedCacheKey } from "@/helpers/teamAuthorization";

const salesDashboardRequestGate = createLatestRequestGate();
const internalDashboardRequestGate = createLatestRequestGate();

export default{
    state:{ 
        dashboardSales: {},

        dashboardInternal:{},
    },
    getters: { 
        dashboardSales: (state) => state.dashboardSales,

        dashboardInternal: (state) => state.dashboardInternal,
    },
    mutations: { 
        setDashboardSales: (state, data) => {
            state.dashboardSales = data;
        },

        setDashboardInternal: (state, data) => {
            state.dashboardInternal = data;
        },
    },
    actions:{
        getSalesDashboard: async ({commit, rootGetters}, teamId = null) => {
                const requestKey = teamScopedCacheKey({ endpoint: "/v1/sales-dashboard", teamId, actorId: rootGetters.loggedUser?.id });
                const { signal } = salesDashboardRequestGate.start(requestKey);
                const response = await api({ requiresAuth: true }).get(
                    "/v1/sales-dashboard",
                    { params: teamQuery(teamId), signal }
                );

                const data = response;
                if (salesDashboardRequestGate.isActive(requestKey)) commit("setDashboardSales", data.data);
                return data;
        },

        getInternalDashboard: async ({commit, rootGetters}, teamId = null) => {
                const requestKey = teamScopedCacheKey({ endpoint: "/v1/internal-dashboard", teamId, actorId: rootGetters.loggedUser?.id });
                const { signal } = internalDashboardRequestGate.start(requestKey);
                const response = await api({ requiresAuth: true }).get(
                    "/v1/internal-dashboard",
                    { params: teamQuery(teamId), signal }
                );

                const data = response;
                if (internalDashboardRequestGate.isActive(requestKey)) commit("setDashboardInternal", data.data);
                return data;
        },
    }
}
